import MessengerMessage from './MessengerMessage';
export default MessengerMessage;
